import { 
  CREATING_USER_GROUP_REQUEST, CREATING_USER_GROUP_SUCCEDDED, CREATING_USER_GROUP_FAILED,
  UPDATING_USER_GROUP_REQUEST, UPDATING_USER_GROUP_SUCCEDDED, UPDATING_USER_GROUP_FAILED,
  FETCHING_USER_GROUPS_REQUEST, FETCHING_USER_GROUPS_SUCCEDDED, FETCHING_USER_GROUPS_FAILED,
  FETCHING_USER_GROUP_REQUEST, FETCHING_USER_GROUP_SUCCEDDED, FETCHING_USER_GROUP_FAILED, 
  DELETING_USER_GROUP_REQUEST, DELETING_USER_GROUP_SUCCEDDED, DELETING_USER_GROUP_FAILED,
  ADD_USER_TO_USER_GROUP, REMOVE_USER_FROM_USER_GROUP
} from './actionTypes.jsx';
import axios from 'axios';
import buildUrl from 'build-url-ts';

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const USER_GROUPS_URL = `${apiUrl}/api/2.0/user_groups`;

/**
* create user group
*/
export function createUserGroup(request) {
  return function (dispatch) {
    dispatch(creatingUserGroup());

    return axios({
      method: 'POST',
      url: USER_GROUPS_URL,
      data: request
    }).then(response => {
      return dispatch(creatingUserGroupSuccedded(response.data))
    }).catch(error => {
      return dispatch(creatingUserGroupFailed(error))
    })
  }
}

function creatingUserGroup() {
  return {
    type: CREATING_USER_GROUP_REQUEST, 
    payload: {}
  }
}

function creatingUserGroupSuccedded(json) {
  return {
    type: CREATING_USER_GROUP_SUCCEDDED,
    payload: json
  }
}

function creatingUserGroupFailed(error) {
  return {
    type: CREATING_USER_GROUP_FAILED,
    payload: error
  }
}

/**
* create user group
*/
export function updateUserGroup(id, request) {
  return function (dispatch) {
    dispatch(updatingUserGroup(id));

    let url = buildUrl(USER_GROUPS_URL, {
      path: `${id}`
    });

    return axios({
      method: 'PUT',
      url: url,
      data: request
    }).then(response => {
      return dispatch(updatingUserGroupSuccedded(id, response.data))
    }).catch(error => {
      return dispatch(updatingUserGroupFailed(id, error))
    })
  }
}

function updatingUserGroup(id) {
  return {
    type: UPDATING_USER_GROUP_REQUEST,
    payload: id
  }
}

function updatingUserGroupSuccedded(id, json) {
  return {
    type: UPDATING_USER_GROUP_SUCCEDDED,
    payload: {
      id: id,
      userGroup: json
    }
  }
}

function updatingUserGroupFailed(id, error) {
  return {
    type: UPDATING_USER_GROUP_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
* Fetch all user groups 
*/
export function fetchUserGroups(page, query) {
  return function (dispatch) {
    dispatch(fetchingUserGroups());

    let param = {
      query: query,
      page: page
    }

    return axios({
      method: 'GET',
      url: USER_GROUPS_URL,
      params: param
    }).then(response => {
      return dispatch(fetchingUserGroupsSuccedded(response.data))
    }).catch(error => {
      return dispatch(fetchingUserGroupsFailed(error))
    })
  }
}

function fetchingUserGroups() {
  return {
    type: FETCHING_USER_GROUPS_REQUEST,
    payload: {}
  }
}

function fetchingUserGroupsSuccedded(json) {
  return {
    type: FETCHING_USER_GROUPS_SUCCEDDED,
    payload: json
  }
}

function fetchingUserGroupsFailed(error) {
  return {
    type: FETCHING_USER_GROUPS_FAILED,
    payload: error
  }
}

/**
* fetch user group for id
*/
export function fetchUserGroup(id) {
  return function (dispatch) {
    dispatch(fetchingUserGroup(id));

    let url = buildUrl(USER_GROUPS_URL, {
      path: `${id}`
    });

    return axios({
      method: 'GET',
      url: url
    }).then(response => {
      return dispatch(fetchingUserGroupSuccedded(id, response.data))
    }).catch(error => {
      return dispatch(fetchingUserGroupFailed(id, error))
    })
  }
}

function fetchingUserGroup(id) {
  return {
    type: FETCHING_USER_GROUP_REQUEST,
    payload: id
  }
}

function fetchingUserGroupSuccedded(id, json) {
  return {
    type: FETCHING_USER_GROUP_SUCCEDDED,
    payload: {
      id: id,
      userGroup: json
    }
  }
}

function fetchingUserGroupFailed(id, error) {
  return {
    type: FETCHING_USER_GROUP_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}


/**
* delete user group 
*/
export function deleteUserGroup(id) {
  return function (dispatch) {
    dispatch(deletingUserGroup(id))

    let url = buildUrl(USER_GROUPS_URL, {
      path: `${id}`
    });

    return axios({
      method: 'DELETE',
      url: url
    }).then(response => {
      return dispatch(deletingUserGroupSUccedded(id, response.data))
    }).catch(error => {
      return dispatch(deletingUserGroupFailed(id, error))
    })
  }
}

function deletingUserGroup(id) {
  return {
    type: DELETING_USER_GROUP_REQUEST,
    payload: id
  }
}

function deletingUserGroupSUccedded(id, json) {
  return {
    type: DELETING_USER_GROUP_SUCCEDDED,
    payload: {
      id: id,
      userGroup: json
    }
  }
}

function deletingUserGroupFailed(id, error) {
  return {
    type: DELETING_USER_GROUP_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
 * Adding and Removing users
 */
export function addUserToUserGroup(id, user) {
  return {
    type: ADD_USER_TO_USER_GROUP,
    payload: {
      id: id,
      user: user
    }
  }
}

export function removeUserFromUserGroup(id, user) {
  return {
    type: REMOVE_USER_FROM_USER_GROUP,
    payload: {
      id: id,
      user: user
    }
  }
}